// Düzenlenmiş MainMeterForm.jsx – Ek ödeme paylaşım tercihleri eklendi
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TariffService from './TariffService';
import SiteService from './SiteService';
import LookUpService from './LookUpService';
import {
    Box,
    Stack,
    Button,
    TextField,
    MenuItem,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    Typography,
    Tooltip,
    FormControlLabel,
    Switch,
    Alert
} from '@mui/material';
import DecimalInput from './UiComponents/DecimalInput';
import TariffSelector from './TariffSelector';

const MainMeterForm = ({ isUpdate }) => {
    const { mainMeterId } = useParams();
    const [name, setName] = useState('');
    const [items, setItems] = useState([]);
    const [contractPower, setContractPower] = useState('');
    const [tariffId, setTariffId] = useState('');
    const [showContractPower, setShowContractPower] = useState(false);
    const [contractPowerRequired, setContractPowerRequired] = useState(false);
    const [contractPowerChargeSharing, setContractPowerChargeSharing] = useState(null);
    const [exceededPowerChargeSharing, setExceededPowerChargeSharing] = useState(null);
    const navigate = useNavigate();
    const [subsidized, setSubsidized] = useState(true);
    const [city, setCity] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [usagePurpose, setUsagePurpose] = useState('');

    const [errors, setErrors] = useState({
        tariffId: false
    });

    const [companies, setCompanies] = useState([]);
    const [usagePurposes, setUsagePurposes] = useState([]);

    const cities = [
        { value: "ADANA", label: "Adana" },
        { value: "ADIYAMAN", label: "Adıyaman" },
        { value: "AFYON", label: "Afyon" },
        { value: "AKSARAY", label: "Aksaray" },
        { value: "AMASYA", label: "Amasya" },
        { value: "ANKARA", label: "Ankara" },
        { value: "ANTALYA", label: "Antalya" },
        { value: "ARDAHAN", label: "Ardahan" },
        { value: "ARTVIN", label: "Artvin" },
        { value: "AYDIN", label: "Aydın" },
        { value: "AGRI", label: "Ağrı" },
        { value: "BALIKESIR", label: "Balıkesir" },
        { value: "BARTIN", label: "Bartın" },
        { value: "BATMAN", label: "Batman" },
        { value: "BAYBURT", label: "Bayburt" },
        { value: "BILECIK", label: "Bilecik" },
        { value: "BINGOL", label: "Bingöl" },
        { value: "BITLIS", label: "Bitlis" },
        { value: "BOLU", label: "Bolu" },
        { value: "BURDUR", label: "Burdur" },
        { value: "BURSA", label: "Bursa" },
        { value: "DENIZLI", label: "Denizli" },
        { value: "DIYARBAKIR", label: "Diyarbakır" },
        { value: "DUZCE", label: "Düzce" },
        { value: "EDIRNE", label: "Edirne" },
        { value: "ELAZIG", label: "Elazığ" },
        { value: "ERZINCAN", label: "Erzincan" },
        { value: "ERZURUM", label: "Erzurum" },
        { value: "ESKISEHIR", label: "Eskişehir" },
        { value: "GAZIANTEP", label: "Gaziantep" },
        { value: "GIRESUN", label: "Giresun" },
        { value: "GUMUSHANE", label: "Gümüşhane" },
        { value: "HAKKARI", label: "Hakkari" },
        { value: "HATAY", label: "Hatay" },
        { value: "ISPARTA", label: "Isparta" },
        { value: "IGDIR", label: "Iğdır" },
        { value: "KAHRAMANMARAS", label: "Kahramanmaraş" },
        { value: "KARABUK", label: "Karabük" },
        { value: "KARAMAN", label: "Karaman" },
        { value: "KARS", label: "Kars" },
        { value: "KASTAMONU", label: "Kastamonu" },
        { value: "KAYSERI", label: "Kayseri" },
        { value: "KILIS", label: "Kilis" },
        { value: "KOCAELI", label: "Kocaeli" },
        { value: "KONYA", label: "Konya" },
        { value: "KUTAHYA", label: "Kütahya" },
        { value: "KIRKLARELI", label: "Kırklareli" },
        { value: "KIRIKKALE", label: "Kırıkkale" },
        { value: "KIRSEHIR", label: "Kırşehir" },
        { value: "MALATYA", label: "Malatya" },
        { value: "MANISA", label: "Manisa" },
        { value: "MARDIN", label: "Mardin" },
        { value: "MERSIN", label: "Mersin" },
        { value: "MUGLA", label: "Muğla" },
        { value: "MUS", label: "Muş" },
        { value: "NEVSEHIR", label: "Nevşehir" },
        { value: "NIGDE", label: "Niğde" },
        { value: "ORDU", label: "Ordu" },
        { value: "OSMANIYE", label: "Osmaniye" },
        { value: "RIZE", label: "Rize" },
        { value: "SAKARYA", label: "Sakarya" },
        { value: "SAMSUN", label: "Samsun" },
        { value: "SIIRT", label: "Siirt" },
        { value: "SINOP", label: "Sinop" },
        { value: "SIVAS", label: "Sivas" },
        { value: "TEKIRDAG", label: "Tekirdağ" },
        { value: "TOKAT", label: "Tokat" },
        { value: "TRABZON", label: "Trabzon" },
        { value: "TUNCELI", label: "Tunceli" },
        { value: "USAK", label: "Uşak" },
        { value: "VAN", label: "Van" },
        { value: "YALOVA", label: "Yalova" },
        { value: "YOZGAT", label: "Yozgat" },
        { value: "ZONGULDAK", label: "Zonguldak" },
        { value: "CANAKKALE", label: "Çanakkale" },
        { value: "CANKIRI", label: "Çankırı" },
        { value: "CORUM", label: "Çorum" },
        { value: "ISTANBUL_ANADOLU_YAKASI", label: "İstanbul - Anadolu" },
        { value: "ISTANBUL_AVRUPA_YAKASI", label: "İstanbul - Avrupa" },
        { value: "IZMIR", label: "İzmir" },
        { value: "SANLIURFA", label: "Şanlıurfa" },
        { value: "SIRNAK", label: "Şırnak" }
    ];

    useEffect(() => {
        SiteService.getAllCompanies()
            .then((res) => {
                setCompanies(res.data);
                console.log('şirketler geldi');
            })
            .catch(err => {
                console.error("Şirket getirme hatası", err);
            });
    }, []);

    useEffect(() => {
        LookUpService.getUsagePurposes()
            .then((res) => {
                setUsagePurposes(res.data);
            })
            .catch(err => {
                console.error("Kullanım amaçları hatası", err);
            });
    }, []);


    useEffect(() => {
        // Yeni kayıt ekranında şehir değişince otomatik şirket seç
        if (!isUpdate && city && companies.length > 0) {
            const matched = companies.find(c => c.cities.some(cty => cty.city === city));
            if (matched) {
                setCompanyId(matched.id);
            }
        }
    }, [city, companies]);

    useEffect(() => {
        TariffService.getTariffs().then((res) => {
            setItems(res.data);
        });

        if (isUpdate && mainMeterId) {
            SiteService.getMainMeterById(mainMeterId).then(async (res) => {
                const {
                    name,
                    tariff,
                    contractPower,
                    contractPowerChargeSharing,
                    exceededPowerChargeSharing,
                    subsidized,
                    city,
                    utilityCompanyDto,
                    usagePurpose
                } = res.data;

                setName(name);
                setTariffId(tariff.tariffId);
                setContractPower(contractPower ?? '');
                setContractPowerChargeSharing(contractPowerChargeSharing ?? null);
                setExceededPowerChargeSharing(exceededPowerChargeSharing ?? null);
                setSubsidized(subsidized);
                setCity(city);
                setCompanyId(utilityCompanyDto?.id || '');
                setUsagePurpose(usagePurpose?.id || '');

                checkContractPowerRequirement(tariff.tariffId);

            });
        }
    }, [isUpdate, mainMeterId]);

    useEffect(() => {
        if (tariffId) {
            checkContractPowerRequirement(tariffId);
        }
    }, [tariffId]);

    const checkContractPowerRequirement = (selectedTariffId) => {
        
        if (!selectedTariffId) return;

        try {
            TariffService.getMainMeterRequiredIndexTypesByTariffId(selectedTariffId).then((res) => {
                const pIndex = res.data.find(i => i.indexType === 'P');
                if (pIndex) {
                    setShowContractPower(true);
                    setContractPowerRequired(pIndex.mainMeterRequired);
                } else {
                    setShowContractPower(false);
                    setContractPowerRequired(false);
                    setContractPower('');
                }
            });
        } catch (error) {
            console.error('Sözleşme gücü kontrolü hatası:', error);
            setShowContractPower(false);
            setContractPowerRequired(true);
        }
    };

    const saveOrUpdateMainMeter = (e) => {
        e.preventDefault();

        const parsedPower = contractPower ? parseFloat(contractPower) : null;
        if (showContractPower && contractPowerRequired && (!contractPower || isNaN(parsedPower))) {
            alert("Lütfen geçerli bir sözleşme gücü girin.");
            return;
        }

        if (showContractPower && (!contractPowerChargeSharing || !exceededPowerChargeSharing)) {
            alert("Lütfen tüm paylaşım seçeneklerini doldurun.");
            return;
        }

        const mainMeter = {
            name,
            tariffId,
            contractPower: showContractPower ? parsedPower : null,
            contractPowerChargeSharing,
            exceededPowerChargeSharing,
            subsidized,
            city: city || null,
            utilityCompany: companyId ? { id: companyId } : null,
            usagePurpose: usagePurpose ? { id: usagePurpose }:null
        };

        const goToList = () => navigate(`/main-meters`);

        if (isUpdate) {
            SiteService.updateMainMeter(mainMeterId, mainMeter).then(goToList);
        } else {
            SiteService.createMainMeter(mainMeter).then(goToList);
        }
    };

    return (
        <Box className="card" sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
            <Typography variant="h5" align="center" gutterBottom>
                {isUpdate ? 'Ana Sayaç Güncelle' : 'Ana Sayaç Ekle'}
            </Typography>
            <form onSubmit={saveOrUpdateMainMeter}>
                <Stack spacing={3}>
                    <TextField
                        required
                        label="Ana Sayaç Adı"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                    />

                    <TariffSelector
                        tariffs={items}
                        value={tariffId}
                        onChange={(tariff) => {
                            setTariffId(tariff?.tariffId);
                        }}
                        error={Boolean(errors.tariffId)}
                        helperText={errors.tariffId && "Tarife seçimi zorunludur"}
                        disabled={false}
                    />

                    <FormControlLabel
                        label="Sübvansiyondan faydalanıyor"
                        control={
                            <Switch
                                checked={subsidized}
                                onChange={(e) => setSubsidized(e.target.checked)}
                                color="primary"
                            />
                        }
                    />

                    {/* SKTT Bilgi Mesajı - Sübvansiyonsuz durumlar için */}
                    {!subsidized && (
                        <Alert severity="info" sx={{ fontSize: '0.875rem' }}>
                            SKTT tarifelerinde otomatik hesaplanan fatura tutarında Epiaş'ın verileri paylaşma tarihine bağlı olarak küçük farklılıklar olabilir. Bu durumda gerçek faturadaki tutarı girebilirsiniz.
                        </Alert>
                    )}

                    {showContractPower && (
                        <DecimalInput
                            label="Sözleşme Gücü"
                            value={contractPower}
                            onChange={setContractPower}
                            decimalSeparator=","
                            maxDecimalDigits={2}
                            required={contractPowerRequired}
                            unit="kW"
                        />
                    )}

                    {showContractPower && (
                        <>
                            <FormControl required fullWidth>
                                <InputLabel>Sözleşme Bedelini Kim Ödesin?</InputLabel>
                                <Select
                                    value={contractPowerChargeSharing}
                                    label="Sözleşme Bedelini Kim Ödesin?"
                                    onChange={(e) => setContractPowerChargeSharing(e.target.value === '' ? null : e.target.value)}
                                >
                                    <MenuItem value="MAIN_METER_ONLY">Ana sayaç ödesin</MenuItem>
                                    <MenuItem value="SUB_METERS_ONLY">Süzme sayaçlar arasında eşit paylaştırılsın</MenuItem>
                                    <MenuItem value="SHARED_BETWEEN_ALL">Ana sayaç ve süzme sayaçlar arasında eşit paylaştırılsın</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl required fullWidth>
                                <InputLabel>Güç Aşım Bedeli Oluşursa Kim Ödesin?</InputLabel>
                                <Select
                                    value={exceededPowerChargeSharing}
                                    label="Güç Aşım Bedeli Oluşursa Kim Ödesin?"
                                    onChange={(e) => setExceededPowerChargeSharing(e.target.value === '' ? null : e.target.value)}
                                >
                                    <MenuItem value="MAIN_METER_ONLY">Ana sayaç ödesin</MenuItem>
                                    <MenuItem value="SUB_METERS_ONLY">Süzme sayaçlar arasında eşit paylaştırılsın</MenuItem>
                                    <MenuItem value="SHARED_BETWEEN_ALL">Ana sayaç ve süzme sayaçlar arasında eşit paylaştırılsın</MenuItem>
                                </Select>
                            </FormControl>
                        </>
                    )}

                    <FormControl fullWidth required>
                        <TextField
                            select
                            fullWidth
                            label="Şehir"
                            value={city}
                            onChange={(e) => setCity(e.target.value === '' ? null : e.target.value)}
                            margin="normal"
                        >
                            {cities.map((c) => (
                                <MenuItem key={c.value} value={c.value}>
                                    {c.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormControl>

                    {city && (
                        <FormControl fullWidth>
                            <InputLabel>Elektrik Şirketi</InputLabel>
                            <Select
                                value={companyId}
                                label="Elektrik Şirketi"
                                onChange={(e) => setCompanyId(e.target.value === '' ? null :e.target.value)}
                            >
                                {companies
                                    .map((c) => (
                                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    )}

                    <FormControl fullWidth>
                        <InputLabel>Süzme Sayaç Kullanım Nedeni</InputLabel>
                        <Select
                            value={usagePurpose}
                            label="Süzme Sayaç Kullanım Nedeni"
                            onChange={(e) => setUsagePurpose(e.target.value)}
                        >
                            {usagePurposes
                                .map((c) => (
                                    <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>

                    <Stack direction="row" spacing={2}>
                        <Button type="submit" variant="contained" color="success">
                            {isUpdate ? 'Güncelle' : 'Kaydet'}
                        </Button>
                        <Button
                            type="button"
                            variant="contained"
                            color="error"
                            onClick={() => navigate(`/main-meters`)}
                        >
                            İptal
                        </Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    );
};

export default MainMeterForm;